<template>
  <Container
    class="grid w-full gap-8 pb-12 pt-4 lg:pb-24 lg:pt-12"
    :class="accordion.length > 1 ? 'lg:grid-cols-2' : 'lg:grid-cols-1'">
    <Accordion :items="accordions[0]" />
    <Accordion
      v-if="accordion.length > 1"
      :items="accordions[1]" />
  </Container>
</template>

<script setup lang="ts">
  import { computed } from 'vue'

  type Props = {
    accordion: {
      title: string
      content: string
    }[]
  }

  const { accordion } = defineProps<Props>()

  const accordions = computed(() => {
    const half = Math.ceil(accordion.length / 2)
    return [accordion.slice(0, half), accordion.slice(half, accordion.length)]
  })
</script>
